import React, { useEffect, useState } from "react";
import SidebarLayout from "../../common/sidebar/SidebarLayout";
import { Helmet } from "react-helmet";
import PatientLoader from "../../common/PatientLoader";
import { InfoCard } from "../dashboard/DashboardHome";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CardLayout from "../../common/cardLayout/CardLayout";
import Select from "react-select";
import {
  findPrevMonth,
  generateMonthlyObjectsReverse,
} from "../../../util/helpers";
import BillingDataTable from "./BillingTable/BillingDataTable";
import {
  bhiPatientLogic,
  patientLogic,
} from "../../../store/features/patient/patientSlice";
import { getAllBHIPatientsLogic } from "../../../store/features/patient/bhiSlice";
import { getStaffLogic } from "../../../store/features/app/appSlice";

const BillingDashboard = () => {
  const [localLoading, setLocalLoading] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const options = generateMonthlyObjectsReverse();
  const { loading, user, staffData } = useSelector((state) => state.app);
  const { bhiLoading } = useSelector((state) => state.bhi);
  const { patientCount, bhiPatientCount } = useSelector(
    (state) => state.patient
  );

  const [selectedYear, setSelectedYear] = useState(options[0]);
  const [clinicStaffData, setClinicStaffData] = useState([]);

  const handleNavigation = (navigate_to) => {
    navigate(navigate_to);
  };

  useEffect(() => {
    if (loading || bhiLoading) {
      setLocalLoading(true);
    }
    if (!loading && !bhiLoading) {
      setLocalLoading(false);
    }
  }, [loading, bhiLoading]);

  useEffect(() => {
    dispatch(getAllBHIPatientsLogic());
    if (user) {
      dispatch(getStaffLogic());

      setClinicStaffData(
        staffData.filter((item) => {
          if (
            item?.role === "CLINIC_ADMIN" ||
            user?.role === "CLINICAL_STAFF"
          ) {
            return item;
          }
        })
      );
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      dispatch(
        patientLogic({
          page_size: 999999,
          page: 1,
          clinic_id: user?.clinic?.id,
          clinician_id: user?.id,
        })
      );
      dispatch(
        bhiPatientLogic({
          page_size: 999999,
          page: 1,
          clinic_id: user?.clinic?.id,
          clinician_id: user?.id,
          bhi_info__id__isnull: false,
          assessed: findPrevMonth(selectedYear), //1st of current month - 1
          bhi_enrollment_date: selectedYear.value, //1st of current month
        })
      );
    }
  }, [user, selectedYear]);

  useEffect(() => {
    if (!localLoading) {
      setSelectedYear(options[0]);
    }
  }, [localLoading]);

  return (
    <>
      <SidebarLayout>
        <section className="p-3">
          <Helmet>
            <meta charSet="utf-8" />
            <title>Billing Dashboard | Precise Digital</title>
            <link rel="canonical" href={window.location.origin} />
          </Helmet>
          {localLoading ? (
            <PatientLoader />
          ) : (
            <>
              <div
                className="container-fluid px-1 py-4 row"
                style={{
                  margin: "0px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div
                  className="col-sm-12 col-md-4 col-lg-4"
                  style={{
                    margin: "0px",
                    padding: "0px",
                    border: "5px solid transparent",
                    boxSizing: "border-box",
                    backgroundClip: "padding-box",
                  }}
                >
                  <InfoCard
                    title={"All Primary Providers"}
                    button_link={"/providers/all/"}
                    button_text={"View All Primary Providers"}
                    stats={clinicStaffData?.length || 0}
                    information={"View all primary provider records"}
                    handleNavigation={handleNavigation}
                    show_link={false}
                  />
                </div>
                <div
                  className="col-sm-12 col-md-4 col-lg-4"
                  style={{
                    margin: "0px",
                    padding: "0px",
                    border: "5px solid transparent",
                    boxSizing: "border-box",
                    backgroundClip: "padding-box",
                  }}
                >
                  <InfoCard
                    title={"All Patients"}
                    button_link={"/providers/all/"}
                    button_text={"View All Patients"}
                    stats={patientCount || 0}
                    information={"View all patient records"}
                    handleNavigation={handleNavigation}
                    show_link={false}
                  />
                </div>
                <div
                  className="col-sm-12 col-md-4 col-lg-4"
                  style={{
                    margin: "0px",
                    padding: "0px",
                    border: "5px solid transparent",
                    boxSizing: "border-box",
                    backgroundClip: "padding-box",
                  }}
                >
                  <InfoCard
                    title={"BHI Eligible Patients"}
                    button_link={"/providers/all/"}
                    button_text={"View All BHI Eligible Patients"}
                    stats={bhiPatientCount || 0}
                    information={"View all BHI Eligible Patients"}
                    handleNavigation={handleNavigation}
                    show_link={false}
                  />
                </div>
              </div>
              <div className="container-fluid">
                <div
                  className="d-flex my-2"
                  style={{
                    alignContent: "center",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <strong>Total billable patients due for: </strong>{" "}
                  <Select
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        border: "0px",
                        borderBottom: "1px solid #94A3B8",
                        borderRadius: "0px",
                      }),
                    }}
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                    value={selectedYear}
                    onChange={(e) => {
                      setSelectedYear(e);
                    }}
                    options={options}
                  />
                </div>
                <CardLayout className="container-fluid p-3 mt-2">
                  {localLoading ? (
                    <PatientLoader />
                  ) : (
                    <BillingDataTable date={selectedYear} />
                  )}
                </CardLayout>
              </div>
            </>
          )}
        </section>
      </SidebarLayout>
    </>
  );
};

export default BillingDashboard;
